import createCachedSelector from 're-reselect';
import {RootState} from '../../rootReducer';
import {WorkspaceOccupancyStateForBuilding} from './types';
import {WorkspaceOccupancyState} from '@lib/infrastructure';

export const getWorkspaceOccupancyLoadingStatusForBuildingId = createCachedSelector(
  [
    (_: RootState, buildingId: string) => buildingId,
    (state: RootState, buildingId: string) => {
      return state.data.sensors.workspaceOccupancyByBuildingId[buildingId];
    },
  ],
  (_buildingId, buildingOccupancy) => buildingOccupancy?.status,
)((_, buildingId) => buildingId);

export const getWorkspaceOccupancyForBuildingId = (buildingId: string) => (state: RootState) =>
  state.data.sensors.workspaceOccupancyByBuildingId[buildingId];

export const getWorkspaceOccupancyForBuildingAndFloorId = createCachedSelector(
  [
    (_: RootState, buildingId: string) => buildingId,
    (_: RootState, _buildingId: string, floorId: string) => floorId,
    (state: RootState, buildingId: string, _floorId: string) => {
      return state.data.sensors.workspaceOccupancyByBuildingId[buildingId] ?? null;
    },
  ],
  (_buildingId, floorId, buildingOccupancy): WorkspaceOccupancyStateForBuilding | null => {
    if (buildingOccupancy === null || buildingOccupancy.status === 'loading' || buildingOccupancy.status === 'failed')
      return buildingOccupancy;

    return {
      ...buildingOccupancy,
      states: buildingOccupancy.states.filter((s) => s.node.parents?.Floor?.id === floorId),
    };
  },
)(
  // Note: this cache does not seem to be hit very often, probably due to
  //       state updates during navigation invalidating the cache?
  (_, buildingId, floorId) => `${buildingId}_${floorId}`,
);

export const getWorkspaceOccupancyForArea = createCachedSelector(
  [
    (_: RootState, buildingId: string) => buildingId,
    (_: RootState, _buildingId: string, areaId: string) => areaId,
    (state: RootState) => state.data.sensors.workspaceOccupancyByBuildingId,
  ],
  (buildingId, areaId, occupancyByBuildingId): WorkspaceOccupancyState | null => {
    const buildingData = occupancyByBuildingId[buildingId];
    return buildingData?.states.find((s) => s.node.id === areaId) ?? null;
  },
)(
  // Note: this cache does not seem to be hit very often, probably due to
  //       state updates during navigation invalidating the cache?
  (_, buildingId, areaId) => `${buildingId}_${areaId}`,
);
